export default __webpack_public_path__ + "static/media/matejkaLogo.3970af4d.webp";